
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"sinistre clos"}},[_c('path',{attrs:{"d":"M35.59 14.8C35.59 6.68 28.6.06 20 .06S4.41 6.68 4.41 14.8a.61.61 0 000 .14v10.43c0 8 7 14.57 15.59 14.57s15.59-6.54 15.59-14.57V15a.61.61 0 000-.2zM20 32.9a15.73 15.73 0 0013.89-8C32.4 30.76 26.74 35.12 20 35.12S7.6 30.76 6.11 24.91A15.73 15.73 0 0020 32.9zM6.15 21.54a15.71 15.71 0 0013.85 8 15.71 15.71 0 0013.85-8A14.13 14.13 0 0120 31.6 14.13 14.13 0 016.15 21.54zM20 1.36c7.88 0 14.29 6 14.29 13.44S27.88 28.25 20 28.25 5.71 22.22 5.71 14.8 12.12 1.36 20 1.36zm0 37.28c-6.74 0-12.4-4.37-13.89-10.21a15.75 15.75 0 0013.89 8 15.75 15.75 0 0013.89-8C32.4 34.27 26.74 38.64 20 38.64z"}}),_c('path',{attrs:{"d":"M13.11 16.48a.65.65 0 00.65.65h1.42c.76 3.12 3.05 5.4 5.74 5.4a5.77 5.77 0 004.93-3.29.65.65 0 00-.26-.88.66.66 0 00-.88.26 4.49 4.49 0 01-3.79 2.6c-2 0-3.71-1.7-4.4-4.09H21a.65.65 0 100-1.3h-4.74c0-.33-.06-.66-.06-1a8.32 8.32 0 01.08-1.12H21a.65.65 0 100-1.3h-4.4c.71-2.33 2.4-4 4.37-4a4.38 4.38 0 013.67 2.39.65.65 0 00.89.23.66.66 0 00.23-.9 5.67 5.67 0 00-4.79-3c-2.66 0-4.92 2.23-5.71 5.29h-1.5a.65.65 0 000 1.3H15a10.36 10.36 0 00-.07 1.12 8.26 8.26 0 00.06 1h-1.2a.65.65 0 00-.68.64z"}})])])
          )
        }
      }
    